import { render, staticRenderFns } from "./orderPair.vue?vue&type=template&id=162ebab9&scoped=true&"
import script from "./orderPair.vue?vue&type=script&lang=js&"
export * from "./orderPair.vue?vue&type=script&lang=js&"
import style0 from "./orderPair.vue?vue&type=style&index=0&id=162ebab9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162ebab9",
  null
  
)

export default component.exports